import React, { useEffect, useState } from 'react';
import { FaBars, FaGithub, FaLinkedin, FaMoon, FaPaperPlane, FaSun, FaTimes } from 'react-icons/fa';

function Sidebar({ profile, navItems, activeSection, isDark, toggleTheme, onSectionSelect }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('portfolioMenuOpen', isMenuOpen);
    return () => document.body.classList.remove('portfolioMenuOpen');
  }, [isMenuOpen]);

  const closeMenu = () => setIsMenuOpen(false);

  const handleNavClick = (event, item) => {
    event.preventDefault();
    onSectionSelect(item.id);
    closeMenu();

    const target = document.getElementById(item.id);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState(null, '', item.href);
    }
  };

  return (
    <header className="portfolioSidebar">
      <div className="portfolioSidebar__profile">
        <img src={profile.image} alt={profile.name} />
        <div>
          <h2>{profile.name}</h2>
          <p>{profile.role}</p>
        </div>
      </div>

      <button
        type="button"
        className="portfolioSidebar__menuButton"
        aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
        aria-expanded={isMenuOpen}
        aria-controls="portfolio-navigation"
        onClick={() => setIsMenuOpen((open) => !open)}
      >
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </button>

      <div className={`portfolioSidebar__menu ${isMenuOpen ? 'is-open' : ''}`} id="portfolio-navigation">
        <nav className="portfolioSidebar__nav" aria-label="Primary navigation">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={activeSection === item.id ? 'is-active' : ''}
              aria-current={activeSection === item.id ? 'page' : undefined}
              onClick={(event) => handleNavClick(event, item)}
            >
              <span>{item.index}</span>
              {item.label}
            </a>
          ))}
        </nav>

        <div className="portfolioSidebar__actions">
          <a href="#contact" className="portfolioSidebar__start" onClick={closeMenu}>
            <FaPaperPlane />
            Start a Project
          </a>
          <a href={profile.github} target="_blank" rel="noreferrer" aria-label="Open GitHub profile">
            <FaGithub />
            <span>GitHub</span>
          </a>
          <a href={profile.linkedIn} target="_blank" rel="noreferrer" aria-label="Open LinkedIn profile">
            <FaLinkedin />
            <span>LinkedIn</span>
          </a>
          <button type="button" onClick={toggleTheme} aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
            {isDark ? <FaSun /> : <FaMoon />}
            <span>{isDark ? 'Light' : 'Dark'}</span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Sidebar;
